export default __webpack_public_path__ + "7791c85a819d081ad592278e01751f0a.svg";